import * as React from 'react';
import styled from 'styled-components';

import { DashboardContent } from '../../assets/contents/dashboard.content';
import logoSrc from '../../assets/images/ea-logo@2x.png';
import { withLocale } from '../contexts/locale.context';
import { LocalStorageKey } from '../enums/local-storage-key.enum';

interface Props {
  localizedContent: DashboardContent;
}

const StLogo = styled.img`
  width: 120px;
  height: 120px;
  margin: 0 48px 0 0;
`;

const StTitle = styled.h1`
  display: inline;
  font-size: 3rem;
  line-height: 1.13;
  color: #ffffff;
`;

class PageHeader extends React.Component<Props> {
  render() {
    const { localizedContent } = this.props;

    const updatedLogoSrc: string = localStorage.getItem(LocalStorageKey.Logo)
      ? `${localStorage.getItem(LocalStorageKey.Logo)}`
      : logoSrc;

    return (
      <>
        <StLogo src={updatedLogoSrc} alt={'EA'} />
        <StTitle>{localizedContent.title}</StTitle>
      </>
    );
  }
}

export default withLocale(PageHeader);



// WEBPACK FOOTER //
// ./src/app/dashboard/components/PageHeader.tsx